<template>
  <div>
    <page-heading :title="pageTitle">
      <div slot="buttons">
        <table>
          <tbody>
            <tr>
              <td>
                <el-button type="info" @click="showDate('back')"><i class="fas fa-arrow-to-left"></i></el-button>
              </td>
              <td>
                <el-date-picker
                  v-model="selectedDate"
                  type="week"
                  placeholder="Quick Search"
                  format="week W of yyyy"
                  :clearable="false">
                </el-date-picker>
              </td>
              <td>
                <el-button type="info" @click="showDate('today')" :disabled="isCurrentWeek">Today</el-button>
              </td>
              <td>
                <!-- <el-button type="info" @click="showDate('forward')" :disabled="isCurrentWeek"><i class="fas fa-arrow-to-right"></i></el-button> -->
                <el-button type="info" @click="showDate('forward')"><i class="fas fa-arrow-to-right"></i></el-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </page-heading>
    <el-row :gutter="20">
      <el-col :span="8">
        <timesheet-overview :week="week" :year="year" :timesheet="timesheet"></timesheet-overview>
        <ptos-for-week v-if="currentUser" :week="week" :year="year" :userId="currentUser.id"></ptos-for-week>
        <comments-list v-if="timesheet" :id="timesheet.id" type="Timesheet" />
      </el-col>
      <el-col :span="16">
        <div v-for="(day, index) in days" :key="index">
          <time-logs :date="day.date" :showEdit="true"></time-logs>
        </div>
      </el-col>
    </el-row>
    <time-log-form-modal></time-log-form-modal>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapGetters, mapActions } from 'vuex';

  import CommentsList from '@/components/comment/CommentsList';
  import PtosForWeek from '@/components/pto/PtosForWeek';
  import TimeLogs from '@/components/timeLog/TimeLogs';
  import TimeLogFormModal from '@/components/timeLog/TimeLogFormModal';
  import TimeLogsWeekView from '@/components/timeLog/TimeLogsWeekView';
  import TimesheetOverview from '@/components/timesheet/TimesheetOverview';

  import { showSuccessMessage, showErrorMessage } from '@/ui/message';
  import durationMixin from '@/store/modules/timeLog/mixins/duration';
  import { formatTime } from '@/filters/time';

  export default {
    name: 'Timesheets',
    components: {
      commentsList: CommentsList,
      ptosForWeek: PtosForWeek,
      timeLogs: TimeLogs,
      timeLogFormModal: TimeLogFormModal,
      timeLogsWeekView: TimeLogsWeekView,
      timesheetOverview: TimesheetOverview,
    },
    mixins: [durationMixin],
    mounted() {
      this.fetchWeekTimesheet();
      this.fetchPtos();
    },
    data() {
      return {
        selectedDate: moment(),
      };
    },
    computed: {
      ...mapGetters('entities/users', ['currentUser']),
      isCurrentWeek() {
        return this.week === moment().startOf('week').week()
          && this.year === moment().startOf('week').weekYear();
      },
      week() {
        return moment(this.selectedDate).startOf('week').week();
      },
      year() {
        return moment(this.selectedDate).startOf('week').weekYear();
      },
      startOfWeek() {
        return this.getSundayStartOfWeek(this.week, this.year);
      },
      endOfWeek() {
        return this.startOfWeek.clone().endOf('week');
      },
      pageTitle() {
        return `Timesheet, Week ${this.week} of ${this.year}`;
      },
      days() {
        const daysCount = 7;
        const days = [];
        for (let i = 1; i < daysCount + 1; i += 1) {
          const date = this.startOfWeek.clone().add(i - 1, 'days');
          const obj = {
            day: i,
            date,
          };
          days.push(obj);
        }
        return days;
      },
      timesheet() {
        const timesheet = this.$store.getters['entities/timesheets/query']()
          .where('week', Number(this.week))
          .where('year', this.year)
          .get();
        return (timesheet && timesheet.length === 1) ? timesheet[0] : null;
      },
    },
    methods: {
      ...mapActions('entities/ptos', ['fetchPtos']),

      getSundayStartOfWeek(week, year) {
        const firstSunday = moment({ year }).startOf('year').startOf('week'); // Sunday on or before Jan 1
        return firstSunday.add(week - 1, 'weeks');
      },
      performAction() {
        if (this.timeLog) {
          if (this.mode === 'edit') {
            this.$store.dispatch('entities/timeLogs/openFormModal', this.timeLog.id);
          } else {
            this.delete(this.timeLog);
          }
        } else {
          this.$store.dispatch('entities/timeLogs/openFormModal');
        }
      },
      delete(timeLog) {
        this.$confirm('Do you really want to delete this time log?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          title: 'Confirm',
        }).then(() => {
          this.$store.dispatch('entities/timeLogs/deleteTimeLog', timeLog.id)
            .then((response) => {
              if (response.status) {
                showSuccessMessage('Time log has been deleted successfully');
              } else {
                showErrorMessage(response.error);
              }
            });
        });
      },
      fetchWeekTimesheet() {
        return this.$store.dispatch('entities/timesheets/fetchTimesheets', { week: this.week, year: this.year });
      },
      showDate(dir) {
        let momentObj = moment().weekYear(this.year)
                                .week(this.week)
                                .startOf('week');

        switch (dir) {
          case 'back':
            momentObj.subtract(1, 'weeks');
            break;
          case 'forward':
            momentObj.add(1, 'weeks');
            break;
          default:
            momentObj = moment().startOf('week');
            break;
        }

        this.selectedDate = momentObj;
        this.fetchWeekTimesheet();
      },
    },
  };
</script>
<style lang="scss">
  .thinner{
    .el-input{
      .el-input__inner{
        width: 100px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/MyTimesheets.vue